import { makeStyles } from '@mui/styles';
import Button from 'apollo-react/components/Button';
import PlusIcon from 'apollo-react-icons/Plus';
import React from 'react';
import { useDispatch } from 'react-redux';

import { useFormSelector } from '../../../../custom-hooks';
import { getUITA } from '../../../../utils/commonUtils';
import { setSelectedControl } from '../../../actions/editor.actions';
import { CREATE_NEW_COMPONENT_STEPS } from '../../../constants/editor.constants';
import { getSelectedControl } from '../../../selectors/editor.selectors';

const useStyles = makeStyles({
  root: {
    minHeight: 15,
    position: 'relative',
    backgroundColor: 'transparent',
  },
  hover: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    minHeight: 10,
    display: 'flex',
    flexDirection: 'row',
    '& button': {
      zIndex: 1000,
      height: '24px',
    },
    '&:before': {
      content: '""',
      flex: '1 1',
      borderBottom: '3px solid #0768fd',
      margin: 'auto',
    },
    '&:after': {
      content: '""',
      flex: '6 1',
      borderBottom: '3px solid #0768fd',
      margin: 'auto',
    },
  },
});

const AddDataModelButton = ({ dispatchStepChange, inTable }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [hoverClass, setHoverClass] = React.useState('');
  const selectedControl = useFormSelector(getSelectedControl);

  const isTestEnv = process.env.NODE_ENV === 'test';

  return (
    <div
      className={classes.root}
      onMouseEnter={(e) => {
        e.stopPropagation();
        setHoverClass(classes.hover);
      }}
      onMouseLeave={(e) => {
        e.stopPropagation();
        setHoverClass('');
      }}
    >
      {(isTestEnv || hoverClass) && (
        <div className={classes.hover}>
          <Button
            variant="primary"
            icon={<PlusIcon />}
            size="small"
            onClick={(e) => {
              dispatchStepChange({ type: { step: CREATE_NEW_COMPONENT_STEPS.STEP_2 } });
              if (inTable && selectedControl?.showControlWrapper) {
                dispatch(setSelectedControl(selectedControl?.selectedControlId, false));
              }
              e.stopPropagation();
            }}
            ui-ta={getUITA('AddControlButton')}
          >
            {'Add Control'}
          </Button>
        </div>
      )}
    </div>
  );
};

export default AddDataModelButton;
